// extracted by mini-css-extract-plugin
module.exports = {"root":"Dot_root__3vw6y","active":"Dot_active__---Wq"};